import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAppAuth } from "@timeghost/auth/react/app-initializer";
import type { JSX } from "react";
import TeamsTabsConfigPage from "@/components/teams/teams-tabs-config-page";

const TeamsTabsConfigRoute = (): JSX.Element => {
	const { authMode, host, account } = useAppAuth();

	if (host !== "teams") {
		return <Navigate to="/not-found" />;
	}
	if (authMode === "guest" || !account) {
		return <Navigate to="/teams/login" />;
	}

	return <TeamsTabsConfigPage />;
};

export const Route = createFileRoute("/teams/tabs-config/")({
	component: TeamsTabsConfigRoute,
});
